export default {
    getContactList: state => {
        return state.contactList
    },
    getContactListConditions: state => {
        return state.contactListConditions
    },
}
